import { modalSelector } from '../components/forms/modal-form';

export const isVisibleFormModal = () => {
  const modal = document.querySelector(modalSelector);
  return !!(modal && modal.classList.contains('visible'));
};
